import { render } from "./contact-messages.vue?vue&type=template&id=3c84e784"
import script from "./contact-messages.vue?vue&type=script&lang=js"
export * from "./contact-messages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__